import { FC, memo, useEffect, useRef, useState } from 'react';
import { isNil } from 'lodash';
// Import Components
import BonusBlockInfo from './BonusBlockInfo';
import BonusBlockConfiguration from './BonusBlockConfiguration';
// Import SCSS
import styles from './cjBonusReceivedPlayersSection.module.scss';

interface Props {
    bonusId: Nilable<number>;
    blockName: string;
}

const BonusBlockExpandedContent: FC<Props> = ({ bonusId, blockName }) => {
    const contentRef = useRef<HTMLDivElement>(null);

    const [remeasureToggle, setRemeasureToggle] = useState(false);

    useEffect(() => {
        const node = contentRef.current;
        if (isNil(node) || typeof ResizeObserver === 'undefined') {
            return;
        }

        let frame = 0;
        const observer = new ResizeObserver(() => {
            // rAF guards against "ResizeObserver loop" warnings by deferring the state update.
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => setRemeasureToggle((prev) => !prev));
        });

        observer.observe(node);

        return () => {
            cancelAnimationFrame(frame);
            observer.disconnect();
        };
    }, []);

    return (
        <>
            <div ref={contentRef} className={styles.nestedBonusInfoContainer}>
                <div className={styles.nestedBonusInfoLeftWrapper}>
                    <BonusBlockInfo bonusId={bonusId} />
                </div>
                <div className={styles.nestedBonusInfoRightWrapper}>
                    <BonusBlockConfiguration blockName={blockName} />
                </div>
            </div>
            {remeasureToggle && <span aria-hidden style={{ display: 'none' }} />}
        </>
    );
};

export default memo(BonusBlockExpandedContent);
